export default __webpack_public_path__ + "static/media/datafarming-rapidem-terms-and-condition.6b9883dd.pdf";